var exports = {
  "e6": "ChannelItem.module__channelItemCore___UWJhY2",
  "$H": "ChannelItem.module__channelItemCoreSelected___UWJhY2",
  "_B": "ChannelItem.module__channelItemCoreUnselected___UWJhY2",
  "Vp": "ChannelItem.module__channelItemCoreHovered___UWJhY2",
  "TV": "ChannelItem.module__typingTooltip___UWJhY2",
  "kp": "ChannelItem.module__channelTypingIndicator___UWJhY2",
  "IM": "ChannelItem.module__typingIndicatorIcon___UWJhY2",
  "U4": "ChannelItem.module__channelItemSelected___UWJhY2",
  "OI": "ChannelItem.module__typingAvatars___UWJhY2",
  "_N": "ChannelItem.module__channelItemIcon___UWJhY2",
  "Jz": "ChannelItem.module__channelItemIconSelected___UWJhY2",
  "Wk": "ChannelItem.module__categoryContainer___UWJhY2",
  "yb": "ChannelItem.module__categoryName___UWJhY2",
  "zc": "ChannelItem.module__iconContainer___UWJhY2",
  "HA": "ChannelItem.module__channelName___UWJhY2",
  "Hq": "ChannelItem.module__actionsContainer___UWJhY2",
  "OO": "ChannelItem.module__channelItemIconUnselected___UWJhY2",
  "Cr": "ChannelItem.module__channelItemIconHighlight___UWJhY2",
  "rC": "ChannelItem.module__channelItemLabel___UWJhY2",
  "gw": "ChannelItem.module__channelItemActions___UWJhY2",
  "kL": "ChannelItem.module__container___UWJhY2",
  "YI": "ChannelItem.module__channelReorderTarget___UWJhY2",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___UWJhY2",
  "XE": "ChannelItem.module__unreadIndicator___UWJhY2",
  "_j": "ChannelItem.module__unreadIndicatorMuted___UWJhY2",
  "fc": "ChannelItem.module__channelItem___UWJhY2",
  "Z$": "ChannelItem.module__channelItemCategory___UWJhY2",
  "RQ": "ChannelItem.module__channelItemRegular___UWJhY2",
  "zx": "ChannelItem.module__channelItemHighlight___UWJhY2",
  "_R": "ChannelItem.module__channelItemMuted___UWJhY2",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___UWJhY2",
  "Fb": "ChannelItem.module__channelItemHoverable___UWJhY2",
  "FN": "ChannelItem.module__channelItemPressed___UWJhY2",
  "Je": "ChannelItem.module__channelItemOver___UWJhY2",
  "X9": "ChannelItem.module__channelItemContextMenu___UWJhY2",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___UWJhY2",
  "GJ": "ChannelItem.module__channelItemDragging___UWJhY2",
  "rO": "ChannelItem.module__channelItemDimmed___UWJhY2",
  "x1": "ChannelItem.module__channelItemMutedState___UWJhY2",
  "Ef": "ChannelItem.module__hoverAffordance___UWJhY2",
  "Mn": "ChannelItem.module__keyboardFocus___UWJhY2",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___UWJhY2",
  "Yq": "ChannelItem.module__categoryContent___UWJhY2",
  "Yl": "ChannelItem.module__categoryIcon___UWJhY2",
  "Sk": "ChannelItem.module__createChannelButton___UWJhY2",
  "$Z": "ChannelItem.module__createChannelIcon___UWJhY2",
  "Ne": "ChannelItem.module__voiceUserCount___UWJhY2",
  "p9": "ChannelItem.module__channelItemVoice___UWJhY2",
  "pL": "ChannelItem.module__contextMenuOpen___UWJhY2",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___UWJhY2",
};

module.exports = exports;
